import { apiUrl } from "../config/api"

export async function listPermissions(userId) {
  let params = {
    userId: userId
  }

  let url = apiUrl('ListAssignedPermissionsByUser')

  return sendReq(params, url)
}

async function sendReq(params, url) {
  let res = await fetch(url, { method: 'POST', body: JSON.stringify(params) })
  return res.json()
}
